import { AddressModel } from '@steelbuy/ts-shared';

import { createCollectionDataContext } from '../../util/provider/CollectionDataProvider';

export const InvoiceAddressCollectionData = createCollectionDataContext<AddressModel>();
